import { render, staticRenderFns } from "./TaksitSayisinaGoreTaksitlendirme.vue?vue&type=template&id=974d92e8&scoped=true"
import script from "./TaksitSayisinaGoreTaksitlendirme.vue?vue&type=script&lang=ts"
export * from "./TaksitSayisinaGoreTaksitlendirme.vue?vue&type=script&lang=ts"
import style0 from "./TaksitSayisinaGoreTaksitlendirme.vue?vue&type=style&index=0&id=974d92e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974d92e8",
  null
  
)

export default component.exports